import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiTabStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            '&:hover': {
                color: variables.colors.palette.primary.main,
            },
            '&.Mui-selected': {
                backgroundColor: variables.colors.palette.primary.main,
                color: 'white',
            },
        },
    },
});

const createMuiTabPanelStyles = () => ({
    styleOverrides: {
        root: {
            padding: '24px 0',
        },
    },
});

const createMuiTabsStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            width: 'fit-content',
            maxWidth: '100%',
            minHeight: 30,
            borderRadius: variables.borderRadius.primary,
            '& .MuiTabs-indicator': {
                display: 'none',
            },
            '& .MuiTabScrollButton-root.Mui-disabled': {
                opacity: 0.2,
            },
        },
    },
});

export { createMuiTabStyles, createMuiTabPanelStyles, createMuiTabsStyles };
